import React from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

export default function Hosting() {
  return (
    <>
    <Administration/>
    <IncludeApplications/>
    </>
  );
}
const  Administration=()=>
{
  
    return(
      <div className="p-4 md:p-6">
      <Card className="shadow-3 border-round-xl">
<div className="flex align-items-center gap-3">
              <i className="pi pi-sliders-h text-bluegray-600 text-3xl"></i>
                <h2 className="text-3xl font-bold text-primary mb-2">
          IBM Jazz Server Administration
        </h2>
          </div>
    
<div className="flex align-items-center gap-">
              <i className="pi pi-star text-yellow-500 text-3xl"></i>
 <p className="text-lg mb-2">What do we provide:</p>
          </div>
       
        <Divider />

        <div className="grid mt-4">

          {/* Deployment */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-cloud-upload text-blue-500 text-xl mt-1"></i>
              <span>
               Deployment of your IBM Collaborative Lifecycle Management in Standard, Departmental, or Enterprise topology
              </span>
            </div>
          </div>

          {/* Hosting */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-globe text-green-500 text-xl mt-1"></i>
              <span>
                Hosting infrastructure for your IBM CLM platform (data centers in the US, Europe, MEA, Africa, APAC, China)
              </span>
            </div>
          </div>

          {/* Maintenance */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-cog text-orange-500 text-xl mt-1"></i>
              <span>
                Maintenance of your CLM platform including updates, patches (iFixes) on customer request
              </span>
            </div>
          </div>

          {/* Service Tickets */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-ticket text-purple-500 text-xl mt-1"></i>
              <span>
                Opening and solving service tickets with IBM on customer request
              </span>
            </div>
          </div>

          {/* Security */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-shield text-indigo-500 text-xl mt-1"></i>
              <span>
                A customizable security model that allows accessing your CLM publicly, via VPN, or from selected IP addresses
              </span>
            </div>
          </div>

          {/* Customization */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-wrench text-teal-500 text-xl mt-1"></i>
              <span>
               Deploying customer customizations to the server
              </span>
            </div>
          </div>

          {/* Logs */}
          <div className="col-12">
            <div className="flex gap-3 p-1 surface-100 border-round-lg mb-1">
              <i className="pi pi-file text-red-500 text-xl mt-1"></i>
              <span>
                Access to log files and server files on request
              </span>
            </div>
          </div>

        </div>
      </Card>
    </div>
    )
}
const IncludeApplications =()=>
{
    return (
    <div className="p-4 md:p-6">
      <Card className="shadow-3 border-round-xl">
<div className="flex align-items-center gap-3">
              <i className="pi pi-server text-blue-500 text-3xl"></i>
   <h2 className="text-3xl font-bold text-primary mb-3">
          Included Applications (Servers) We Can Manage for You:
        </h2>          </div>
     

        <Divider />

        {/* Licensed Applications */}
        <div className="flex align-items-center gap-3">
              <i className="pi pi-ticket text-orange-500 text-3xl"></i>
  <h3 className="text-xl font-semibold mt-2 mb-2 text-blue-600">
      Applications that require licenses:
        </h3>          </div>
      

        <div className="grid">
          {[
            "IBM Rational DOORS Next Generation",
            "IBM Rational Team Concert",
            "IBM Rational Quality Manager",
            "IBM Rational Design Manager",
            "IBM Rational Model Manager",
            "IBM Rational Engineering Lifecycle Manager",
            "IBM Rational Publishing Engine Web"
          ].map((app, index) => (
            <div key={index} className="col-12 md:col-6">
              <div className="flex align-items-start gap-3 p-1 surface-100 border-round-lg mb-1">
                <i className="pi pi-briefcase text-blue-500 text-xl mt-1"></i>
                <span>{app}</span>
              </div>
            </div>
          ))}
        </div>

        <Divider />

        {/* Non Licensed Applications */}
        <div className="flex align-items-center gap-3">
              <i className="pi pi-thumbs-up text-green-500 text-3xl"></i>
    <h3 className="text-xl font-semibold mt-2 mb-2 text-green-600">
        Applications which do not require licenses:
        </h3>          </div>
    

        <div className="grid">
          {[
            "Jazz Team Server (mandatory)",
            "Global Configurations Management",
            "Jazz Reporting Service",
            "Lifecycle Query Engine",
            "Data Collection Component",
            "Data Warehouse"
          ].map((app, index) => (
            <div key={index} className="col-12 md:col-6">
              <div className="flex align-items-start gap-3 p-1 surface-100 border-round-lg mb-1">
                <i className="pi pi-database text-green-500 text-xl mt-1"></i>
                <span>{app}</span>
              </div>
            </div>
          ))}
        </div>

      </Card>
    </div>
    )
}